<template>
  <div>
    <label :for="name" class="is-block height-inherit">
      <slot>
      </slot>
    </label>
    <file-upload
        :multiple="multiple"
        :name="name"
        :drop="true"
        v-model="files"
        @input-file="inputFile"
        @input-filter="inputFilter"
        :accept="accept"
        :extensions="extensions"
        :size="size"
        ref="upload">
    </file-upload>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component';
import compressionFichier from '@/services/piecesJointes/compression';

export default {
  name: 'GeneralUploader',
  props: {
    background: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'uploader',
    },
    accept: String,
    extensions: RegExp,
    size: Number,
  },
  components: {
    FileUpload,
  },
  data() {
    return {
      files: [],
    };
  },
  methods: {
    async inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          this.$emit('filePrevented', { message: this.$i18n.t('piecesJointes.errors.typeNotAllowed'), file: newFile });
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|js?|vue?|exe?)$/i.test(newFile.name)) {
          this.$emit('filePrevented', { message: this.$i18n.t('piecesJointes.errors.typeNotAllowed'), file: newFile });
          return prevent();
        }
        if (this.extensions && !this.extensions.test(newFile.name)) {
          this.$emit('filePrevented', { message: this.$i18n.t('piecesJointes.errors.typeNotAllowed'), file: newFile });
          return prevent();
        }
        if (this.size < newFile.size) {
          this.$emit('filePrevented', { message: this.$i18n.t('piecesJointes.errors.fileWithNameTooBig', { fileName: newFile.name, maxSize: this.size / 1024 / 1024 }), file: newFile });
          return prevent();
        }
        // Automatic compression
        newFile.error = 'compressing';
        if (newFile.file && newFile.type.substr(0, 6) === 'image/' && newFile.size > 0) {
          const compressed = await compressionFichier(newFile.file);
          newFile.compressedFile = compressed;
        }
        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          // Create a blob field
          newFile.blob = '';
          const URL = window.URL || window.webkitURL;
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file);
          }
          // Thumbnails
          newFile.thumb = '';
          if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
            newFile.thumb = newFile.blob;
          }
        }
      }
      this.$emit('added', newFile);
      return newFile;
    },
    inputFile(newFile, oldFile) {
      if (!newFile && oldFile) {
        this.$emit('removed', oldFile);
      }
    },
    remove(file) {
      this.$refs.upload.remove(file);
    },
  },
};
</script>
